<idt-common-styles-render
  *ngIf="piece"
  [styles]="piece.settings?.styles">
  <div #hudsonScript></div>
</idt-common-styles-render>
